﻿/**
 * @param {String} HTML representing any number of sibling elements
 * @return {NodeList}
 */
export const render = (html, onlyBody = false) => {
    var parser = new DOMParser();
	var doc = parser.parseFromString(html, 'text/html');
    if (onlyBody) {
        return doc.body;
    } else {
        return doc.body.childNodes[0];
    }
}

/**
 * The following formats are available:
 * mm:      e.g. 01 to 12       (Months)
 * dd:      e.g. 01 to 31       (Days)
 * yy:      e.g. 01 to 99       (Years sliced in 2 digits)
 * YYYY:    e.g. 2000 to 2031   (Years)
 * hh:      e.g. 01 to 23       (Hours)
 * ii:      e.g. 01 to 59       (Minutes)
 * ss:      e.g. 01 to 59       (Seconds)
 * @param {Date} date here a date object is given
 * @param {String} format the format of the date can be specified here
 * @returns {String}
 */
export const formatDate = (date, format) => {
    const slicedYear = Number(date.getFullYear().toString().slice(-2));
    const map = {
        mm: (date.getMonth() + 1) < 10 ? `0${(date.getMonth() + 1)}` : date.getMonth() + 1,
        dd: date.getDate() < 10 ? `0${date.getDate()}` : date.getDate(),
        yy: slicedYear < 10 ? `0${slicedYear}` : slicedYear,
        YYYY: date.getFullYear(),
        hh: date.getHours() < 10 ? `0${date.getHours()}` : date.getHours(),
        ii: date.getMinutes() < 10 ? `0${date.getMinutes()}` : date.getMinutes(),
        ss: date.getSeconds() < 10 ? `0${date.getSeconds()}` : date.getSeconds()
    }

    return format.replace(/mm|dd|yy|YYYY|hh|ii|ss/g, matched => map[matched])
}

/**
 * This function creates an hashcode of a string. It can be used for comparisons of strings
 * @param {String} str
 * @return {Number}
 */
export const hashCode = (str) => str.split('').reduce((s, c) => Math.imul(31, s) + c.charCodeAt(0) | 0, 0);

export const delay = ms => new Promise(res => setTimeout(res, ms));

export const isClickInWrapper = (event, wrapper) => {
    const wrapperDimension = wrapper.getBoundingClientRect()
    return !(
        event.clientX < wrapperDimension.left ||
        event.clientX > wrapperDimension.right ||
        event.clientY < wrapperDimension.top ||
        event.clientY > wrapperDimension.bottom
    )
}

export const toggleScrollability = (isActive) => {
    const html = document.querySelector("html")
    if (isActive) {
        html.style.setProperty("overflow", "hidden")
    } else {
        html.style.removeProperty("overflow")
    }
}

export const setCookie = (name, value, days) => {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    document.cookie = `${name}=${value};expires=${date.toUTCString()};path=/`
}

export const checkCookie = (name) => {
    return document.cookie.split(';').some(item => item.includes(name))
}